import React from 'react';
import styles from './Main.module.css'

import ShephaLogo from '../../../assets/ShephaLogo';
import ShephaTitleLogo from '../../../assets/shephaTitleLogo.png'
import HomeBg from '../../../assets/HomeBg'

const main = ({ onGetStartedClick }) => {


    return (

        <div className={styles.container}>
            <HomeBg className={styles.background}/>
            <img src={ShephaTitleLogo} className={styles.shephaTitleLogo} />
            <img src={ShephaTitleLogo} className={styles.shephaTitleLogo} />
            <div className={styles.contentContainer}>
                <ShephaLogo size={252} className={styles.shephaLogo} />
                <div className={styles.innerContentContainer}>
                    <p className={styles.innerContentContainerTitle}>Hebrew never been easier. Ever.</p>
                    <p className={styles.innerContentContainerButton} onClick={onGetStartedClick}>GET STARTED</p>
                </div>
            </div>

        </div>
    );
}

export default main;